import { useState } from 'react';
import { generateClassName } from '@klv/shared/utils/functions';
import type { IRoiCalculator, ICalculatedRoiType } from './types';
import { Wrapper } from '@klv/utils/wrapper';
import RoiForm from './components/roi-form';
import RoiResults from './components/roi-results';
import * as styles from './styles/roicalculator.module.scss';


const RoiCalculator = ({ fadeIn = false, customPadding = { customPaddingBottom: 'default', customPaddingTop: 'default' } }: IRoiCalculator) => {
  const [calculatedRoi, setCalculatedRoi] = useState<ICalculatedRoiType>({
    total: '',
    subscriberRevenue:'',
    campaignsRevenue:'',
    flowsRevenue:'', 
    activeProfiles: '',
  });

  return (
    <Wrapper contained={false} customPadding={customPadding} backgroundColor='lightSand' fadeIn={fadeIn ? .25 : 0}>
    <div className={styles.fullWidth}>
      <div className={generateClassName(['grid', styles.roiCalculatorContainer])}>
        <RoiForm calculatedRoi={calculatedRoi} setCalculatedRoi={setCalculatedRoi} />
        <RoiResults calculatedRoi={calculatedRoi} />
      </div>
    </div>
    </Wrapper>
  );
};

export default RoiCalculator;
